(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    var selectors = [
      '[id*="__product_list_themegen"]',
      '[id*="__section_x8mrnx"]'
    ];
    var sections = document.querySelectorAll(selectors.join(','));

    if (reduceMotion || !('IntersectionObserver' in window)) {
      sections.forEach(function (el) { el.classList.add('is-visible'); });
      document.querySelectorAll('.product-card').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var sectionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('av-section-reveal', 'is-visible');
        sectionObserver.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });

    sections.forEach(function (el) {
      el.classList.add('av-section-reveal');
      sectionObserver.observe(el);
    });

    var cards = document.querySelectorAll('.product-card');
    var cardObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var index = Array.prototype.indexOf.call(cards, el);
        window.setTimeout(function () {
          el.classList.add('is-visible');
        }, Math.max(0, index) * 80);
        cardObserver.unobserve(el);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });

    cards.forEach(function (el) {
      el.classList.add('av-card-stagger');
      cardObserver.observe(el);
    });
  });
})();
